import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const CONFIG_ENDPOINT = 'config/v1';

export const BASE_URL = `${serverUrl}/${CONFIG_ENDPOINT}`;
